var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import MapMarker from "../base/MapMarker";
import { Icon, Marker } from 'leaflet';
var LeafletMarker = /** @class */ (function (_super) {
    __extends(LeafletMarker, _super);
    function LeafletMarker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LeafletMarker.prototype.createMarkerInternal = function () {
        var marker = new Marker(this.location.toLatLng(), { icon: new Icon(this.icon) });
        if (this.hasPopup()) {
            marker.bindPopup(this.generatePopupContent());
        }
        return marker;
    };
    LeafletMarker.prototype.addTo = function (map) {
        this.marker.addTo(map.map);
        return this;
    };
    LeafletMarker.prototype.show = function () {
        this.marker.getElement().style.display = '';
    };
    LeafletMarker.prototype.hide = function () {
        this.marker.getElement().style.display = 'none';
        this.marker.closePopup();
        this.marker.closeTooltip();
    };
    LeafletMarker.prototype.remove = function () {
        this.marker.remove();
    };
    LeafletMarker.prototype.showPopup = function () {
        this.marker.openPopup();
    };
    LeafletMarker.prototype.hidePopup = function () {
        this.marker.closePopup();
    };
    return LeafletMarker;
}(MapMarker));
export default LeafletMarker;
